/** App\Enums\PageStatus */
export enum PageStatus {
  Pending = 'pending',
  InternalReview = 'internal_review',
  ClientReview = 'client_review',
  Revise = 'revise',
  Approved = 'approved',
}
